export enum WorkOrderStatus {
  SCHEDULED = 'SCHEDULED',
  PENDING = 'PENDING',
  DRAFT = 'DRAFT',
  IN_PROGRESS = 'IN_PROGRESS',
  WAITING_PARTS = 'WAITING_PARTS',
  WAITING_APPROVAL = 'WAITING_APPROVAL',
  RESOLVED = 'RESOLVED',
  COMPLETED = 'COMPLETED',
  CANCELLED = 'CANCELLED',
  INVOICED = 'INVOICED',
}

/** Folhas ainda na oficina (exclui agendado, concluído, faturado, cancelado). */
export const IN_WORKSHOP_STATUSES: WorkOrderStatus[] = [
  WorkOrderStatus.PENDING,
  WorkOrderStatus.DRAFT,
  WorkOrderStatus.IN_PROGRESS,
  WorkOrderStatus.WAITING_PARTS,
  WorkOrderStatus.WAITING_APPROVAL,
  WorkOrderStatus.RESOLVED,
]

export function isWorkOrderInWorkshop(status: WorkOrderStatus): boolean {
  return IN_WORKSHOP_STATUSES.includes(status)
}

export interface WorkOrderServiceItem {
  id?: number
  workOrderId?: number
  costId?: number // When set, item came from Cost catalog
  serviceDescription: string
  hours: number
  hourlyRate: number
  subtotal?: number
  notes?: string
  createdAt?: string
  updatedAt?: string
  createdBy?: number
  createdByName?: string
}

export interface WorkOrderPieceItem {
  id?: number
  workOrderId?: number
  pieceId?: number // Null when from Cost catalog
  costId?: number // When set, item came from Cost catalog
  companyPieceId?: number
  pieceDescription: string
  quantity: number
  unitPrice: number
  subtotal?: number
  notes?: string
  createdAt?: string
  updatedAt?: string
  createdBy?: number
  createdByName?: string
}

export interface WorkOrderBudgetCost {
  id?: number
  workOrderId?: number
  description: string
  amount: number
  createdAt?: string
  createdBy?: number
}

export interface WorkOrder {
  id: number
  workOrderNumber: string
  workshopCompanyId: number
  customerCompanyId?: number
  vehicleId: number
  status: WorkOrderStatus
  description?: string
  diagnosis?: string
  observations?: string
  // Dados do mecânico (separados dos dados da rececionista)
  mechanicDescription?: string
  mechanicDiagnosis?: string
  mechanicObservations?: string
  laborCost: number
  partsCost: number
  totalCost: number
  discountPercentage?: number
  discountAmount?: number
  taxPercentage?: number
  taxAmount?: number
  finalAmount: number
  extraAmount?: number
  useManualFinalAmount?: boolean
  estimatedHours?: number
  actualHours?: number
  hourlyRate?: number
  startDate?: string
  expectedCompletionDate?: string
  actualCompletionDate?: string
  createdBy: number
  assignedMechanicId?: number
  createdAt: string
  updatedAt?: string
  approvedAt?: string
  approvedBy?: number
  invoiceNumber?: string
  invoiceDate?: string
  serviceItems?: WorkOrderServiceItem[]
  pieceItems?: WorkOrderPieceItem[]
  budgetCosts?: WorkOrderBudgetCost[]
  // Informações adicionais para exibição
  customerCompanyName?: string
  customerPhone?: string
  customerEmail?: string
  vehicleInfo?: string
  vehicleRegistrationPlate?: string
  vehicleFuelType?: string
  vehicleColor?: string
  workshopCompanyName?: string
  assignedMechanicName?: string
  customerData?: string
  vehicleData?: string
}

export interface CreateWorkOrderRequest {
  workshopCompanyId: number
  customerCompanyId?: number
  vehicleId: number
  description?: string
  diagnosis?: string
  observations?: string
  discountPercentage?: number
  taxPercentage?: number
  estimatedHours?: number
  hourlyRate?: number
  expectedCompletionDate?: string
  createdBy: number
  assignedMechanicId?: number
  serviceItems?: Omit<WorkOrderServiceItem, 'id' | 'workOrderId' | 'subtotal' | 'createdAt' | 'updatedAt'>[]
  pieceItems?: Omit<WorkOrderPieceItem, 'id' | 'workOrderId' | 'subtotal' | 'createdAt' | 'updatedAt'>[]
}

export interface WorkOrderCompletionCheck {
  ready: boolean
  missingFields: string[]
}

export interface UpdateWorkOrderRequest {
  description?: string
  diagnosis?: string
  observations?: string
  // Dados do mecânico (separados dos dados da rececionista)
  mechanicDescription?: string
  mechanicDiagnosis?: string
  mechanicObservations?: string
  status?: WorkOrderStatus
  discountPercentage?: number
  taxPercentage?: number
  extraAmount?: number
  finalAmount?: number
  useManualFinalAmount?: boolean
  estimatedHours?: number
  actualHours?: number
  hourlyRate?: number
  expectedCompletionDate?: string
  assignedMechanicId?: number
  serviceItems?: Omit<WorkOrderServiceItem, 'id' | 'workOrderId' | 'subtotal' | 'createdAt' | 'updatedAt' | 'createdBy' | 'createdByName'>[]
  pieceItems?: Omit<WorkOrderPieceItem, 'id' | 'workOrderId' | 'subtotal' | 'createdAt' | 'updatedAt' | 'createdBy' | 'createdByName'>[]
  updatedBy?: number
}


